/**
 * Review Card Interactions
 * Handles show more/less functionality for review content
 */
class ReviewCardInteractions {
  constructor() {
    this.init();
  }

  init() {
    this.attachEventListeners();
  }

  attachEventListeners() {
    // Handle show more/less buttons
    document.addEventListener("click", (e) => {
      if (e.target.classList.contains("review-card__show-more")) {
        this.toggleReviewContent(e.target);
      }
    });
  }

  toggleReviewContent(button) {
    const contentEl = button.previousElementSibling;
    const fullContent = contentEl.dataset.fullContent;
    const isExpanded = button.textContent.includes("Show less");

    if (isExpanded) {
      // Collapse
      const truncatedContent = fullContent.substring(0, 300) + "...";
      contentEl.textContent = truncatedContent;
      button.textContent = "Show more";
    } else {
      // Expand
      contentEl.textContent = fullContent;
      button.textContent = "Show less";
    }
  }
}

// Initialize when DOM is loaded
document.addEventListener("DOMContentLoaded", () => {
  new ReviewCardInteractions();
});
